module.exports = [{
      plugin: require('C:/Users/artur/lostit/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
